// extracted by mini-css-extract-plugin
export default {"addForm":"style_addForm__qw2Y3","label":"style_label__fr2fd","note":"style_note__DhFpA","fileInput":"style_fileInput__VpwSI","githubLink":"style_githubLink__3GjnW"};